import React, { ChangeEvent, useState, useEffect } from "react";
import SelectItem from "../../models/shared/SelectItem";
import { TransportOptionType } from "../../models/transport-option-type/TransportOptionType";
import { VehicleType } from "../../models/vehicle-type/VehicleType";
import TransportOptionTypeApiClient from "../../api/TransportOptionTypeApiClient";
import VehicleTypeApiClient from "../../api/VehicleTypeApiClient";
import ValidityRangeReasonApiClient from "../../api/ValidityRangeReasonApiClient";
import ValidityRangeReason from "../../models/financing-request/validity-range/ValidityRangeReason";
import CompanionInPublicTransportTypeApiClient from "../../api/CompanionInPublicTransportTypeApiClient";
import { CompanionInPublicTransportType } from "../../models/companion-transport-types/CompanionInPublicTransportType";

interface Props {
  getTransportOptionType?: boolean;
  getVehicleType?: boolean;
  getValidityRangeReason?: boolean;
  getCompanionTransportType?: boolean;
}

const useCodeBook = ({
  getTransportOptionType = false,
  getVehicleType = false,
  getValidityRangeReason = false,
  getCompanionTransportType = false,
}: Props) => {
  const [
    transportOptionTypeSelectItems,
    setTransportOptionTypeSelectItems,
  ] = useState<SelectItem<TransportOptionType>[]>(
    new Array<SelectItem<TransportOptionType>>()
  );
  const [vehicleTypeSelectItems, setVehicleTypeSelectItems] = useState<
    SelectItem<VehicleType>[]
  >(new Array<SelectItem<VehicleType>>());
  const [
    validityRangeReasonSelectItems,
    setValidityRangeReasonSelectItems,
  ] = useState<SelectItem<ValidityRangeReason>[]>(
    new Array<SelectItem<ValidityRangeReason>>()
  );
  const [
    companionTransportTypeSelectItems,
    setCompanionTransportTypeSelectItems,
  ] = useState<SelectItem<CompanionInPublicTransportType>[]>(
    new Array<SelectItem<CompanionInPublicTransportType>>()
  );

  useEffect(() => {
    const getTransportOptionTypes = async () => {
      const apiClient = new TransportOptionTypeApiClient();
      const transportOptionTypes = await apiClient.getTransportOptionTypes();

      setTransportOptionTypeSelectItems([...transportOptionTypes]);
    };

    const getVehicleTypes = async () => {
      const apiClient = new VehicleTypeApiClient();
      const vehicleTypes = await apiClient.getVehicleTypes();

      setVehicleTypeSelectItems([...vehicleTypes]);
    };

    async function getValidityRangeReasons() {
      const apiClient = new ValidityRangeReasonApiClient();
      const reasons = await apiClient.getValidityRangeReasons();

      setValidityRangeReasonSelectItems(reasons);
    }

    async function getCompanionTransportTypes() {
      const apiClient = new CompanionInPublicTransportTypeApiClient();
      const companionTransportTypes = await apiClient.getCompanionTransportTypes();

      setCompanionTransportTypeSelectItems(companionTransportTypes);
    }

    if (
      getTransportOptionType &&
      (transportOptionTypeSelectItems == null ||
        transportOptionTypeSelectItems.length == 0)
    ) {
      getTransportOptionTypes();
    }

    if (
      getVehicleType &&
      (vehicleTypeSelectItems == null || vehicleTypeSelectItems.length == 0)
    ) {
      getVehicleTypes();
    }

    if (
      getValidityRangeReason &&
      (validityRangeReasonSelectItems == null ||
        validityRangeReasonSelectItems.length == 0)
    ) {
      getValidityRangeReasons();
    }

    if (
      getCompanionTransportType &&
      (companionTransportTypeSelectItems == null ||
        companionTransportTypeSelectItems.length == 0)
    ) {
      getCompanionTransportTypes();
    }
  }, []);

  return {
    transportOptionTypeSelectItems,
    vehicleTypeSelectItems,
    validityRangeReasonSelectItems,
    companionTransportTypeSelectItems,
  };
};

export default useCodeBook;
